import { useContractScreensHeaderInteractor } from './interactor';
import InteractiveButton from '../../../../components/InteractiveButton/InteractiveButton';
import IconPlus from '../../../../components/Icons/IconPlus/IconPlus';

export const ContractScreensHeader = () => {
  const { contractName, canCreateCycle, canCreateScreen, handleCreateCycle, handleCreateScreen } =
    useContractScreensHeaderInteractor();

  return (
    <div className="p-contract-screens-view__header flex flex-col xsm:flex-row w-full xsm:items-center justify-between">
      <h2 className="text-title-md md:text-title-md2 truncate font-semibold max-xsm:pb-2 text-black dark:text-white">
        {contractName ? contractName : 'Loading ...'}
      </h2>
      <div className="flex flex-col xsm:flex-row gap-2">
        {canCreateCycle && (
          <InteractiveButton
            as="a"
            iconLeft={<IconPlus />}
            text="Add new cycle"
            onClick={handleCreateCycle}
            className="cursor-pointer text-nowrap"
          />
        )}
        {canCreateScreen && (
          <InteractiveButton
            as="a"
            iconLeft={<IconPlus />}
            text="Add screen"
            onClick={handleCreateScreen}
            className="cursor-pointer text-nowrap"
          />
        )}
      </div>
    </div>
  );
};
